import React from 'react'
import styled from 'styled-components'
import { B_NUM, I_NUM, N_NUM, G_NUM, O_NUM } from './CardNumbersMap'

const CardBody = styled.div`
  margin: 0 10px 10px;
  display: grid;
  grid-template-columns: 80px 80px 80px 80px 80px;
  text-align: center;

  &.pattern {
    label {
      &:not(.target):not(.free) {
        filter: blur(1px);
        opacity: 0.15;
        color: #ccc;
      }
    }
  }

  @media (max-width: 460px) {
    grid-template-columns: 20% 20% 20% 20% 20%;
    margin: 0 0 10px;
  }

  @media print {
    margin: 0 6px;
    grid-template-columns: 40px 40px 40px 40px 40px;
  }
`

const Col = styled.div`
  > label {
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border: 1px solid #c7c7c7;
    font-size: 32px;
    cursor: pointer;
    user-select: none;

    @media (max-width: 460px) {
      width: 100%;
      height: auto;
      padding: 10px;
      font-size: 18px;
    }

    @media print {
      width: 100%;
      height: 40px;
      font-size: 18px;
    }

    &:hover {
      background: var(--main-color-light);

      @media (hover: none) {
        background: none;
        color: #000;
      }
    }

    &:focus {
      background: var(--main-color-light);
    }

    &.active {
      background: var(--main-color-dark);
      color: #fff;
    }

    &.free {
      font-size: 18px;
      font-weight: bold;
      pointer-events: none;

      @media (max-width: 460px) {
        font-size: 16px;
        padding: 11px 10px;
      }

      @media print {
        width: 100%;
        font-size: 13px;
        font-weight: normal;
      }
    }
  }

  input {
    display: none;
  }

  input:checked + label {
    background: var(--main-color-dark);
    color: #fff;
  }
`

function MakeCardBody({ name, number, setWinningCard }) {
  const generateRandomNum = (arr) => {
    const randomIndex = Math.floor(Math.random() * arr.length)
    const generatedNum = arr[randomIndex]
    arr.splice(randomIndex, 1)

    return generatedNum
  }

  const checkWinningCard = () =>
    [...document.querySelectorAll('.pattern')].some((parent) => {
      let checkbox = []
      Object.keys(parent.children).forEach((k1) => {
        Object.keys(parent.children[k1].children).forEach((k2) => {
          if (
            parent.children[k1].children[k2].nodeName === 'LABEL' &&
            parent.children[k1].children[k2].classList.contains('target')
          ) {
            const TARGET_EL = parent.children[k1].children[k2]
            checkbox.push(TARGET_EL.previousSibling.checked)
          }
        })
      })
      let win = !checkbox.some((c) => c === false)
      setWinningCard(win)
      return win
    })

  const COL_CARD_NUM = ({ col, id, free = false }) => {
    if (free) return <label className={`active free`}>FREE</label>
    const rand = generateRandomNum(col)
    return (
      <>
        <input
          type="checkbox"
          id={`${name}-${id}`}
          defaultChecked={false}
          className={`num-${rand}`}
        />
        <label
          onClick={() => {
            // What's happening is that we trigger the target radio 3 times
            // This is to sync all Cards cheked numbers
            // Check the complete numbers board
            // 1. Check = True

            document.querySelector(
              `#ctl-${rand}`
            ).checked = !document.querySelector(`#ctl-${rand}`).checked

            // Check all the cards
            // 2. Check = False
            document
              .querySelectorAll(`.num-${rand}`)
              .forEach((i) => (i.checked = !i.checked))

            // Negate the target radio check
            // 3. Check = True
            document.querySelector(
              `#${name}-${id}`
            ).checked = !document.querySelector(`#${name}-${id}`).checked

            // setTimeout(checkWinningCard, 100)
          }}
          htmlFor={`${name}-${id}`}
          className={`col-${id}`}
        >
          {rand}
        </label>{' '}
      </>
    )
  }

  const COL_CARD_GENERATOR = ({ col, columnLetter }) => {
    if (columnLetter === 'B') {
      return (
        <Col>
          {COL_CARD_NUM({ col, id: 'B1' })}
          {COL_CARD_NUM({ col, id: 'B2' })}
          {COL_CARD_NUM({ col, id: 'B3' })}
          {COL_CARD_NUM({ col, id: 'B4' })}
          {COL_CARD_NUM({ col, id: 'B5' })}
        </Col>
      )
    }

    if (columnLetter === 'I') {
      return (
        <Col>
          {COL_CARD_NUM({ col, id: 'I1' })}
          {COL_CARD_NUM({ col, id: 'I2' })}
          {COL_CARD_NUM({ col, id: 'I3' })}
          {COL_CARD_NUM({ col, id: 'I4' })}
          {COL_CARD_NUM({ col, id: 'I5' })}
        </Col>
      )
    }

    if (columnLetter === 'N') {
      return (
        <Col>
          {COL_CARD_NUM({ col, id: 'N1' })}
          {COL_CARD_NUM({ col, id: 'N2' })}
          {COL_CARD_NUM({ col, id: 'N3', free: true })}
          {COL_CARD_NUM({ col, id: 'N4' })}
          {COL_CARD_NUM({ col, id: 'N5' })}
        </Col>
      )
    }

    if (columnLetter === 'G') {
      return (
        <Col>
          {COL_CARD_NUM({ col, id: 'G1' })}
          {COL_CARD_NUM({ col, id: 'G2' })}
          {COL_CARD_NUM({ col, id: 'G3' })}
          {COL_CARD_NUM({ col, id: 'G4' })}
          {COL_CARD_NUM({ col, id: 'G5' })}
        </Col>
      )
    }

    if (columnLetter === 'O') {
      return (
        <Col>
          {COL_CARD_NUM({ col, id: 'O1' })}
          {COL_CARD_NUM({ col, id: 'O2' })}
          {COL_CARD_NUM({ col, id: 'O3' })}
          {COL_CARD_NUM({ col, id: 'O4' })}
          {COL_CARD_NUM({ col, id: 'O5' })}
        </Col>
      )
    }
  }
  return (
    <CardBody className={`card ${name}`}>
      {COL_CARD_GENERATOR({
        col: [...B_NUM],
        columnLetter: 'B',
      })}
      {COL_CARD_GENERATOR({
        col: [...I_NUM],
        columnLetter: 'I',
      })}
      {COL_CARD_GENERATOR({
        col: [...N_NUM],
        columnLetter: 'N',
      })}
      {COL_CARD_GENERATOR({
        col: [...G_NUM],
        columnLetter: 'G',
      })}
      {COL_CARD_GENERATOR({
        col: [...O_NUM],
        columnLetter: 'O',
      })}
    </CardBody>
  )
}

export default React.memo(MakeCardBody)
